import { CaretRightOutlined } from '@ant-design/icons';
import { Drawer, Form, Space, Spin, Tooltip } from "antd";
import TextArea from "antd/es/input/TextArea";
import { APP_TIMESTAMP_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from "app/config/store";
import { TimeDifference } from "app/shared/util/help";
import dayjs from 'dayjs';
import * as _ from "lodash";
import React, { useEffect, useState } from "react";
import { createComment, getComment, getReplyComment, replyComment as reply } from "./comment.reducer";
import './style.scss';

type ICommentProps = {
    isOpenDrawerComment: boolean;
    handleDrawerComment: () => void;
    topicId?: string;
}
const CommentComponent = ({ isOpenDrawerComment, handleDrawerComment, topicId }: ICommentProps) => {
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();

    const entities = useAppSelector(state => state.comments.entities);
    const isLoading = useAppSelector(state => state.comments.loading);
    const isUpdateSuccess = useAppSelector(state => state.comments.updateSuccess);
    const account = useAppSelector(state => state.authentication.account);
    const [replyComment, setReplyComment] = useState(null);
    const [comment, setComment] = useState(null);
    const [treeData, setTreeData] = useState([]);

    useEffect(() => {
        if (entities) {
            setTreeData(entities.map(item => {
                return {
                    ...item,
                    children: item.childComment ? [item.childComment] : []
                }
            }))
        }
    }, [entities]);

    useEffect(() => {
        handleGetComment();
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        const payload = {
            content: comment,
            topicId,
            authorId: account.id,
            authorInfomation: JSON.stringify({
                id: account.id,
                name: account.userName,
            })
        }
        dispatch(createComment(payload))
        setComment(null);
        const newTree = [...treeData,
        {
            content: comment,
            topicId,
            authorId: account.id,
            authorInfomation: JSON.stringify({
                id: account.id,
                name: account.userName,
            })
        }]
        setTreeData(newTree)
    }

    const handleReply = (event, data, value) => {
        event.preventDefault();
        const payload = {
            content: value,
            topicId,
            parentCommentId: data.id,
            authorId: account.id,
            creationTime: dayjs(),
            authorInfomation: JSON.stringify({
                id: account.id,
                name: account.userName
            })
        }
        setReplyComment((prevReplyComment) => ({
            ...prevReplyComment,
            [data.id]: "",
        }));
        const newTree = updateTreeWithChildren(treeData, data.id, [payload]);
        setTreeData(newTree)
        dispatch(reply(payload)).then((res) => {
            // if (res && res.payload) {
            //     // Show more replies for the current comment
            //     handleShowMoreReply(data.id);
            // }
            return;
        })
    }

    const handleGetComment = () => {
        if (topicId) {
            dispatch(getComment(topicId));
        }

    }

    const handleKeyDown = (event) => {
        setComment(event.target.value)
        if (event.key === 'Enter') {
            handleSubmit(event);
        }
    }

    const handleKeyDownResponse = (event, item) => {
        if (event.key === 'Enter') {
            handleReply(event, item, event.target.value);
        }
    }

    const handleChangeReply = (event, item) => {
        setReplyComment({
            ...replyComment,
            [item.id]: event.target.value
        });
    }

    const handleChangeComment = (event) => {
        setComment(event.target.value);
    }

    const handleShowResponse = (item) => {
        const replyItem = { ...replyComment }
        replyItem[item.id] = "";
        setReplyComment(replyItem);
    }

    const handleMapNewTree = (idReply, children) => {
        const newTree = updateTreeWithChildren(treeData, idReply, children);
        setTreeData(newTree);
    }

    const handleShowMoreReply = (idReply) => {
        dispatch(getReplyComment(idReply)).then((response) => {
            if (response && response.payload) {
                const children = (response.payload as any).data;
                handleMapNewTree(idReply, children)
            }
        });
    };

    const updateTreeWithChildren = (nodes, parentId, newChildren) => {
        return nodes.map((node) => {
            if (node.id === parentId) {
                const newChild = _.uniqBy(
                    [...(node.children ?? []), ...newChildren],
                    'creationTime'
                );
                return { ...node, children: _.orderBy([...newChild], ['creationTime'], ['asc']) };
            }
            if (node.children) {
                return {
                    ...node,
                    children: updateTreeWithChildren(node.children, parentId, newChildren),
                };
            }
            return node;
        });
    };

    const renderResponse = (item, isChildren = false) => {
        const hasChildren = item.children?.length > 0;
        return (
            <div key={item.id} className={`container-response ${hasChildren ? 'has-children' : ''} ${isChildren ? 'is-children' : ''}`}>
                <div className="user-response d-grid">
                    <Space className="fw-bold">
                        {JSON.parse(item?.authorInfomation)?.name}
                    </Space>
                    <Space className="body-reply">
                        {item.content}
                    </Space>
                </div>
                <div className="response-action">
                    <Tooltip title={`${dayjs(item.creationTime).format(APP_TIMESTAMP_FORMAT)}`}>
                        <span>{TimeDifference(item.creationTime)}</span>
                    </Tooltip>
                    {item.authorId !== account?.id &&
                        <span onClick={() => { handleShowResponse(item) }} className="text-primary cursor-pointer">Phản hồi</span>
                    }
                    <span onClick={() => { handleShowMoreReply(item.id) }} className="text-primary cursor-pointer">Xem thêm</span>
                </div>
                {hasChildren &&
                    item.children?.map(child => {
                        return (
                            <>
                                {renderResponse(child, true)}
                            </>
                        )
                    })}
                {(replyComment && replyComment[item.id] !== null && replyComment[item.id] !== undefined) && (
                    <div className="input-response mb-1 w-100">
                        <TextArea value={replyComment[item.id] || ""} onChange={(e) => { handleChangeReply(e, item) }} className="w-100" placeholder="Nhập ý kiến phản hồi" rows={2} size="large" onKeyDown={(e) => { handleKeyDownResponse(e, item) }} />
                        <CaretRightOutlined color="blue" onClick={(e) => { handleReply(e, item, replyComment[item.id]) }} className="icon" />
                    </div>
                )}
            </div>
        )
    }

    return (
        <Drawer maskClosable={false} width={500} className="vh-70" title="Ý kiến trao đổi" footer={
            <div className="input-response">
                <TextArea value={comment} onChange={handleChangeComment} className="w-100 " rows={2} placeholder="Nhập ý kiến" size="large" onKeyDown={handleKeyDown} />
                <CaretRightOutlined onClick={handleSubmit} className="icon" />
            </div>
        } onClose={handleDrawerComment} open={isOpenDrawerComment}>
            <Spin spinning={isLoading} delay={300}>
                <div className="tree">
                    {treeData?.map(item => {
                        return (
                            <>
                                <div className={`container-response`}>
                                    {renderResponse(item)}
                                </div>
                            </>
                        )
                    })}
                </div>
            </Spin>
        </Drawer>
    );
}
export default CommentComponent